module.exports = __webpack_public_path__ + "img/u116.6c8fb2af.png";